import { put, call, all, spawn, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../constants/organization';
import { apiGetUserInformation } from '../actions/user_information';
import { organizationServices } from 'Redux/services/organization';
import parseDjangoError from 'Utils/parseDjangoError';

/** Save the organization, then refetch user information — the single place
 *  organization data is cached for the whole app. */
function* apiUpdateOrganizationWorker(action) {
  try {
    yield call(organizationServices.apiUpdateOrganization, action);
    toast.success('Organization Updated Successfully!');
    yield put(apiGetUserInformation(action.userInformationId, action.token));
  } catch (err) {
    toast.error(parseDjangoError(err?.response?.data));
  }
}

function* apiUpdateOrganizationWatcher() {
  yield takeLatest(types.API_UPDATE_ORGANIZATION, apiUpdateOrganizationWorker);
}

export default function* organizationRootSaga() {
  const sagas = [apiUpdateOrganizationWatcher];

  yield all(
    sagas.map(saga =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log(e);
          }
        }
      }),
    ),
  );
}
